// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Invoices_mainWrapper__-4t7u"};